import { render, staticRenderFns } from "./EntityColumnConfig.vue?vue&type=template&id=1005e489&scoped=true"
import script from "./EntityColumnConfig.vue?vue&type=script&lang=js"
export * from "./EntityColumnConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1005e489",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1005e489')) {
      api.createRecord('1005e489', component.options)
    } else {
      api.reload('1005e489', component.options)
    }
    module.hot.accept("./EntityColumnConfig.vue?vue&type=template&id=1005e489&scoped=true", function () {
      api.rerender('1005e489', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entities/EntityColumnConfig.vue"
export default component.exports